import Service from "./Service";
const baseurl = '/api/historia-educacion';

export default {
    showByHc(idHistoria) {
        return Service.get(`${baseurl}/show-by-hc/${idHistoria}`);
    },
    showByUsuario(idUsuario) {
        return Service.get(`${baseurl}/show-by-usuario/${idUsuario}`);
    },
    showLastByUsuario(idUsuario) {
        return Service.get(`${baseurl}/show-last-by-usuario/${idUsuario}`);
    },
    store(data) {
        return Service.post(`${baseurl}/store`, data);
    },
    storeUser(data) {
        return Service.post(`${baseurl}/store-user`, data);
    },
    delete(id) {
        return Service.delete(`${baseurl}/delete/${id}`);
    },
    print(id) {
        return `${process.env.VUE_APP_BASE_PATH}${baseurl}/print/${id}`;
    }
};
